<div class="w-full">
    <div class="flex items-center">
        <input type="checkbox" id="checkbox" [formControl]="inputFormControl"
            class="w-4 h-4 rounded-[4px] border-[#c2c2c2] mr-2">
        <p class="font-monsterrat font-medium text-sm leading-6 text-[#252c32]">
            <ng-content />
        </p>
    </div>
</div>